import React, { useEffect } from "react";
import { Form, Input } from 'antd';
import FormItem from "components/fields/FormItem";
import { connect } from "react-redux";
import { 
	getJobRoleRequestDetails, 
	doJobRoleRequestCreate, 
	doJobRoleRequestUpdate 
} from "../../../../redux/jobrolerequest/jobRoleRequestState";
import CrudButtons from "components/button/crudbuttons";
import { requiredField } from "utils/crudSagaHelper";
import DynamicList from "components/fields/DynamicList";
import { getLabel } from "utils";
import { MODULE_JOBROLE_REQS, DATE_FORMAT } from "variables/constants";
import dayjs from "dayjs";
import JobRoleRequestFormFields from "./JobRoleRequestFormFields";
import Button from "components/button";

const JobRoleRequestForm = ({
	recordData,
	getDetails,
	doCreate, 
	doUpdate, 
	onCancel,
	submitLabel,
	getRecord,
	...props
}) => {
	
  	const [form] = Form.useForm();
	const { recordId, mode } = props;
	const { TextArea } = Input;  	

	useEffect(() => {
		if(recordId){
			getRecord(recordId);
		}
	}, [recordId, getRecord]);

	useEffect(() => {
		if(recordData){
			form.resetFields();
			const { job_role:jobRole, jrr_job_role_id, ...rest } = recordData;

			const initialValues = {
				...rest,
				...jobRole,
				jrr_target_date: recordData?.jrr_target_date ? dayjs(recordData.jrr_target_date) : null,
				jro_key_responsibilities: Array.isArray(jobRole?.jro_key_responsibilities)
					? recordData.job_role.jro_key_responsibilities
					: recordData.job_role.jro_key_responsibilities
					? JSON.parse(recordData.job_role.jro_key_responsibilities)
					: [""],
				jro_preferred_qualifications: Array.isArray(jobRole?.jro_preferred_qualifications)
					? recordData.job_role.jro_preferred_qualifications
					: recordData.job_role.jro_preferred_qualifications
					? JSON.parse(recordData.job_role.jro_preferred_qualifications)
					: [""],
			};	
			form.setFieldsValue(initialValues);
		}
    }, [recordData, form]);

  	const onSubmit = (formData) => {	
    	try {  
			formData.jrr_target_date= formData.jrr_target_date.format(`${DATE_FORMAT}`);
			recordData.jrr_id > 0 ? doUpdate(formData): doCreate(formData); 
    	} catch (error) {
      		console.error('Save failed:', error);
    	}
  	};

	const onCreateJobPost = (formData) => {
		try {  
			doUpdate(formData); 
    	} catch (error) {
      		console.error('Save failed:', error);
    	}
	}
  
  	return (
    	<Form className="form"
			form={form} 
			layout="vertical"
			onFinish={onSubmit}
		>   
			<FormItem
				name="jrr_id"
				hidden
			>
				<Input type="hidden"/>
			</FormItem>

			<div className="pb-6 p-8 space-y-6">
				<JobRoleRequestFormFields recordData={recordData} mode="view"/>
			
				<div className="grid grid-cols-1 md:grid-cols-2 gap-6">
					<div className="md:col-span-2">
						<DynamicList 
							name="jro_key_responsibilities"
							label="Key Responsibilities"
							placeholder="Enter responsibility"
							addButtonClass="text-gray-500 dark:text-white"
							mode={mode}
							recordData={recordData?.job_role?.jro_key_responsibilities}
						/>
					
						<FormItem className="font-medium mt-2 mb-2 w-full"
							name="jro_add_info"
							label="Additonal Information"
							>
							{mode !== "view" ?
							<TextArea id="jro_add_info"
								className="input-field"
								rows={3}
								maxLength={500}		            		
								/>
							: 
							<label className="text-base label-value dark:text-white">
								{recordData?.job_role?.jro_add_info}
							</label>
							}
						</FormItem>
					</div>
					<FormItem className="font-medium mb-2"
						label="Location"
						name="jro_location"
					>
						{mode !== 'view' ?
							<Input id="jro_location"
								className="input-field"
								type="text"
								placeholder="Enter location"
							/>
							: 
							<label className="text-base label-value dark:text-white">
								{recordData?.job_role?.jro_location}
							</label>
						}
					</FormItem>
				</div>
			</div>

			<div className="w-full flex justify-end">
				<CrudButtons
					mode={mode}
					recordId={recordData?.jrr_id ?? 0}
					isModal={true}
					modalId={recordData?.jrr_id > 0 ? 'edit_job_role_request' : 'add_job_role_request'}
					cancelLabel="Cancel"
					doHideModal={onCancel}
					submitLabel={submitLabel}
					moduleId={MODULE_JOBROLE_REQS}
				>
					{recordData?.jrr_status_id === 77 && 
						<Button 
							type="button" 
							className="crud-button" 
							onClick={onCreateJobPost}
						>
							Create Job Post
						</Button>
					}
				</CrudButtons>
			</div> 				 			
		</Form>	 	
  	);
};

const mapStateToProps = (state) => ({
  	recordData: state.jobRoleRequest.jobRoleRequestDetails?.data,
});

const mapDispatchToProps = (dispatch) => ({
	getRecord: (id) => dispatch(getJobRoleRequestDetails(id)),
  	doCreate: (data) => dispatch(doJobRoleRequestCreate(data)),
  	doUpdate: (data) => dispatch(doJobRoleRequestUpdate(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(JobRoleRequestForm);
